import { z } from 'zod'

// Used in scraping brand logos into the database
export type BrandLogo = {
  brand_id: string
  brand: string
  domain: string
  logos: string[]
}

export type BrandLogoResponse = BrandLogo[]

// Our stored brand logo data
const alphamapBrandLogoSchema = z.object({
  brandId: z.string(),
  s3Key: z.string(),
  name: z.string(),
})
export type AlphamapBrandLogo = z.infer<typeof alphamapBrandLogoSchema>

export const BASE_IMAGE_URL = 'https://assets.alphamap.com/brand-logos/'

export const brandLogosInRadiusRequestShema = z.object({
  latlng: z.array(z.number()).length(2),
  radius: z.number().min(1).max(50),
  limit: z.number().min(1).max(100),
})
export type BrandLogosInRadiusRequest = z.infer<typeof brandLogosInRadiusRequestShema>

export const brandLogosInRadiusResponseSchema = z.array(alphamapBrandLogoSchema)
export type BrandLogosInRadiusResponse = z.infer<typeof brandLogosInRadiusResponseSchema>
